module.exports = __webpack_public_path__ + "img/PharaohsOfTheNile_EGM.472aac15.jpg";